import React, {Component} from "react";
import CareerStatsTab from "./CareerStatsTab";
import StatsAndVideosPerMatchTab from "../StatsAndVideosPerMatch";
import TransfersTab from "./TransfersTab";
import ScoutingReportsTab from "./ScoutingReportsTab";
import HorizontalTabs from "../../../../ui/tabs/HorizontalTabs";
import '@brainhubeu/react-carousel/lib/style.css';
import {removeWatchlist} from "../../../../../store/actions/WatchlistActions";
import {setFullProfilePlayerId} from "../../../../../store/actions/Dashboard/FullProfile/FullProfileActions";
import {connect} from "react-redux";

class InformationTabs extends Component {
    /**
     * Render the rest of player details shown as tabs in the bottom of the page.
     * @returns {React.ReactNode} The rest of player details.
     */

    render = () => {
        const items = [
            HorizontalTabs.createItem('Career Stats', <CareerStatsTab/>),
            HorizontalTabs.createItem('Stats And Views Per Match', <StatsAndVideosPerMatchTab/>),
            HorizontalTabs.createItem('Transfers', <TransfersTab/>),
            HorizontalTabs.createItem('Scouting Reports', <ScoutingReportsTab/>),
        ];

        return (
            <HorizontalTabs items={items}/>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        playerId: state.full_profile.playerId
    }
};

export default connect(mapStateToProps, null)(InformationTabs);
